import './Loading.css';

function Loading() {

    return <div className='container-loading'>
        <div className="loader">
        </div>
    </div>
}

export default Loading;